import React from "react"
import { Link } from "react-router-dom"

export default function TemplateAvailability() {
  return (
    <div>
      <h1>This template is not available for this Organization</h1>
      <Link
        to="/"
        style={{ marginBottom: 30, display: "inline-block" }}
        className="btn"
      >
        Back to Dashboard
      </Link>
    </div>
  )
}
